// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3utGy","second-card":"_2shUr"};